import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUtensils, faPalette, faStar, faCheck, faArrowRight, faTimes, faEye, faWineBottle, faImages } from '@fortawesome/free-solid-svg-icons';
import '../styles/services/ServicesPage.css';
import SEOHead from '../components/Common/SEOHead';
import WebPreloader from '../components/Common/WebPreloader';
import bannerImage from '../../images/ServicesPage/TravelWebKitBase_ServicesBanner.png';
import CustomBoatLeadModal from '../components/HomePage/CustomBoatLeadModal';
import FAQ from '../components/HomePage/FAQ';
import PDFViewer from '../components/Common/PDFViewer';
import ServicesGalleryModal from '../components/ServicesPage/ServicesGalleryModal';
import DecorationPDF1 from '../../images/PDFs/DecorationPDF/Mr.Sea_Decorations_PDF-1.png';
import DecorationPDF2 from '../../images/PDFs/DecorationPDF/Mr.Sea_Decorations_PDF-2.png';
import DecorationPDF3 from '../../images/PDFs/DecorationPDF/Mr.Sea_Decorations_PDF-3.png';
import DecorationPDF4 from '../../images/PDFs/DecorationPDF/Mr.Sea_Decorations_PDF-4.png';
import DecorationPDF5 from '../../images/PDFs/DecorationPDF/Mr.Sea_Decorations_PDF-5.png';
import DecorationPDF6 from '../../images/PDFs/DecorationPDF/Mr.Sea_Decorations_PDF-6.png';
import DecorationPDF7 from '../../images/PDFs/DecorationPDF/Mr.Sea_Decorations_PDF-7.png';
import LiquorsPDF1 from '../../images/PDFs/LiquorsPDF/MrSea_Liquors_PDF-1.png';
import LiquorsPDF2 from '../../images/PDFs/LiquorsPDF/MrSea_Liquors_PDF-2.png';
import LiquorsPDF3 from '../../images/PDFs/LiquorsPDF/MrSea_Liquors_PDF-3.png';
import LiquorsPDF4 from '../../images/PDFs/LiquorsPDF/MrSea_Liquors_PDF-4.png';
import LiquorsPDF5 from '../../images/PDFs/LiquorsPDF/MrSea_Liquors_PDF-5.png';
import LiquorsPDF6 from '../../images/PDFs/LiquorsPDF/MrSea_Liquors_PDF-6.png';
import CateringPDF1 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-1.png';
import CateringPDF2 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-2.png';
import CateringPDF3 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-3.png';
import CateringPDF4 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-4.png';
import CateringPDF5 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-5.png';
import CateringPDF6 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-6.png';
import CateringPDF7 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-7.png';
import CateringPDF8 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-8.png';
import CateringPDF9 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-9.png';
import CateringPDF10 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-10.png';
import CateringPDF11 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-11.png';
import CateringPDF12 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-12.png';
import CateringPDF13 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-13.png';
import CateringPDF14 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-14.png';
import CateringPDF15 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-15.png';
import CateringPDF16 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-16.png';
import CateringPDF17 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-17.png';
import CateringPDF18 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-18.png';
import CateringPDF19 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-19.png';
import CateringPDF20 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-20.png';
import CateringPDF21 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-21.png';
import CateringPDF22 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-22.png';
import CateringPDF23 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-23.png';
import CateringPDF24 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-24.png';
import CateringPDF25 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-25.png';
import CateringPDF26 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-26.png';
import CateringPDF27 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-27.png';
import CateringPDF28 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-28.png';
import CateringPDF29 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-29.png';
import CateringPDF30 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-30.png';
import CateringPDF31 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-31.png';
import CateringPDF32 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-32.png';
import CateringPDF33 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-33.png';
import CateringPDF34 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-34.png';
import CateringPDF35 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-35.png';
import CateringPDF36 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-36.png';
import CateringPDF37 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-37.png';
import CateringPDF38 from '../../images/PDFs/CateringPDF/MrSea_PDF_Catering-38.png';

// Import service gallery images
import ServicesGallery1 from '../../images/ServicesPage/DecorationsGallery/MrSea_Decorations_GalleryImage1.png';
import ServicesGallery2 from '../../images/ServicesPage/DecorationsGallery/MrSea_Decorations_GalleryImage2.png';
import ServicesGallery3 from '../../images/ServicesPage/DecorationsGallery/MrSea_Decorations_GalleryImage3.png';
import ServicesGallery4 from '../../images/ServicesPage/DecorationsGallery/MrSea_Decorations_GalleryImage4.png';
import ServicesGallery5 from '../../images/ServicesPage/DecorationsGallery/MrSea_Decorations_GalleryImage5.png';
import ServicesGallery6 from '../../images/ServicesPage/DecorationsGallery/MrSea_Decorations_GalleryImage6.png';
import ServicesGallery7 from '../../images/ServicesPage/DecorationsGallery/MrSea_Decorations_GalleryImage7.png';

const ServicesPage = () => {
  const [showPreloader, setShowPreloader] = useState(true);
  const [activeSection, setActiveSection] = useState('hero');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [currentPdf, setCurrentPdf] = useState(null);
  const [leadModalType, setLeadModalType] = useState(null); // null | 'catering' | 'decorations' | etc
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [galleryCurrentIndex, setGalleryCurrentIndex] = useState(0);

  // Services gallery images
  const servicesGalleryImages = [
    ServicesGallery1,
    ServicesGallery2,
    ServicesGallery3,
    ServicesGallery4,
    ServicesGallery5,
    ServicesGallery6,
    ServicesGallery7
  ];

  useEffect(() => {
    const timer = setTimeout(() => setShowPreloader(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    const sections = document.querySelectorAll('.services-section, .services-hero__title, .services-hero__subtitle');
    sections.forEach((section) => {
      observer.observe(section);
    });

    const handleScroll = () => {
        const sectionsForNav = [
            { id: 'hero' }, { id: 'intro' }, { id: 'catering' }, { id: 'decorations' }
        ];
        
        const scrollPosition = window.scrollY + window.innerHeight * 0.5;

        let currentActive = 'hero';
        for (const section of sectionsForNav) {
            const element = document.getElementById(section.id);
            if (element && element.offsetTop <= scrollPosition) {
                currentActive = section.id;
            }
        }
        setActiveSection(currentActive);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      sections.forEach((section) => {
        if (section) observer.unobserve(section);
      });
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openPdfModal = (pdfType) => {
    setCurrentPdf(pdfType);
    setShowPdfModal(true);
  };

  const closePdfModal = () => {
    setShowPdfModal(false);
    setCurrentPdf(null);
  };

  const openGalleryModal = () => {
    setShowGalleryModal(true);
    setGalleryCurrentIndex(0);
  };

  const closeGalleryModal = () => {
    setShowGalleryModal(false);
    setGalleryCurrentIndex(0);
  };

  const navItems = [
    { id: 'hero', icon: faStar, label: 'Top' },
    { id: 'intro', icon: faStar, label: 'Intro' },
    { id: 'catering', icon: faUtensils, label: 'Catering' },
    { id: 'decorations', icon: faPalette, label: 'Decor' }
  ];

  const cateringFeatures = [
    { icon: faCheck, text: 'Fully Customizable Menu to Fit Your Event Theme' },
    { icon: faCheck, text: 'Wide Variety of Fresh, High-Quality Food Options' },
    { icon: faCheck, text: 'Premium Quality Ingredients' },
    { icon: faCheck, text: 'Premium Liquor Selection' },
    { icon: faCheck, text: 'All Logistics Handled... You Just Show Up' }
  ];

  const decorationFeatures = [
    { icon: faCheck, text: 'Custom Theme Design' },
    { icon: faCheck, text: 'Professional Setup' },
    { icon: faCheck, text: 'Complete Package Options' }
  ];

  return (
    <div className="services-page-immersive">
      <SEOHead pageType="services" />
      {showPreloader && <WebPreloader />}

      <nav className="services-side-nav">
        <ul>
          {navItems.map(item => (
            <li key={item.id} className={activeSection === item.id ? 'active' : ''}>
              <button onClick={() => scrollToSection(item.id)} title={item.label}>
                <FontAwesomeIcon icon={item.icon} />
                <span className="nav-label">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Hero Section */}
      <section id="hero" className="services-hero">
        <div className="services-hero__bg-image" style={{ backgroundImage: `url(${bannerImage})` }}></div>
        <div className="services-hero__overlay"></div>
        <div className="services-hero__content">
            <h1 className="services-hero__title">Premium Yacht Services</h1>
            <p className="services-hero__subtitle">Catering & Decorations for Unforgettable Miami Experiences</p>
            <div className="services-hero__cta-buttons">
                <button className="hero-cta catering-cta" onClick={() => scrollToSection('catering')}>
                    <FontAwesomeIcon icon={faUtensils} />
                    <span>Explore Catering</span>
                    <FontAwesomeIcon icon={faArrowRight} />
                </button>
                <button className="hero-cta decorations-cta" onClick={() => scrollToSection('decorations')}>
                    <FontAwesomeIcon icon={faPalette} />
                    <span>View Decorations</span>
                    <FontAwesomeIcon icon={faArrowRight} />
                </button>
            </div>
        </div>
        <div className="services-hero__wave-container">
            <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
            <defs>
            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
            </defs>
            <g className="parallax">
            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(0, 96, 152, 0.2)" />
            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(0, 96, 152, 0.4)" />
            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(0, 96, 152, 0.6)" />
            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#006098" />
            </g>
            </svg>
        </div>
      </section>
      
      <main className="services-content">
        {/* Introduction Section */}
        <section id="intro" className="services-section services-intro">
            <div className="services-container">
                <h2>Personalize Your Journey</h2>
                <p className="services-intro__subtitle">
                    Your yacht charter is more than just a ride, it's an experience. Our premium services 
                    transform your time on the water into unforgettable memories.
                </p>
                <div className="services-intro__stats">
                    <div className="stat-item">
                        <div className="stat-number">500+</div>
                        <div className="stat-label">Happy Clients</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-number">50+</div>
                        <div className="stat-label">Menu Options</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-number">100%</div>
                        <div className="stat-label">Satisfaction</div>
                    </div>
                </div>
                
                <div className="services-intro__highlights">
                    <div className="highlight-item">
                        <h3>Catering Excellence</h3>
                        <p>From Peruvian ceviche to premium sushi platters, charcuterie boards, and fresh fruit arrangements... all paired with a wide liquor selection at market prices. Menus are fully customizable to match your preferences or special requests.</p>
                    </div>
                    <div className="highlight-item">
                        <h3>Decoration Magic</h3>
                        <p>Three unique packages (Basic, Standard, Premium) featuring weather-resistant marine-safe decorations, floating drink holders, LED signs, and personalized touches for any occasion.</p>
                    </div>
                </div>
            </div>
        </section>

        {/* Catering Section */}
        <section id="catering" className="services-section services-catering">
            <div className="services-container">
                <div className="service-header catering-header">
                    <div className="service-icon">
                        <FontAwesomeIcon icon={faUtensils} />
                    </div>
                    <h2>Premium Catering Services</h2>
                    <p>Your event, your way... pick from our flavorful catering options and premium drink selection.</p>
                </div>
                
                <div className="service-content">
                    <div className="service-features">
                        <h3>What's Included</h3>
                        <div className="features-grid">
                            {cateringFeatures.map((feature, index) => (
                                <div key={index} className="feature-item">
                                    <FontAwesomeIcon icon={feature.icon} />
                                    <span>{feature.text}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    
                    <div className="service-cta">
                        <div className="cta-content">
                            <h3>Download Our Catering Menu</h3>
                            <p>Explore our complete selection of premium dishes, beverages, and liquor options</p>
                            <div className="cta-buttons">
                                <button 
                                    className="cta-button primary"
                                    onClick={() => openPdfModal('catering-menu')}
                                >
                                    <FontAwesomeIcon icon={faUtensils} />
                                    <span>Preview Catering Menu</span>
                                </button>
                                <button 
                                    className="cta-button primary"
                                    onClick={() => openPdfModal('liquor-menu')}
                                >
                                    <FontAwesomeIcon icon={faWineBottle} />
                                    <span>Preview Liquor Menu</span>
                                </button>
                                <button 
                                    className="cta-button secondary"
                                    onClick={() => { setIsModalOpen(true); setLeadModalType('catering'); }}
                                >
                                    <FontAwesomeIcon icon={faStar} />
                                    <span>Book Catering</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* Decorations Section */}
        <section id="decorations" className="services-section services-decorations">
            <div className="services-container">
                <div className="service-header decorations-header">
                    <div className="service-icon">
                        <FontAwesomeIcon icon={faPalette} />
                    </div>
                    <h2>Custom Decoration Packages</h2>
                    <p>Three unique packages to perfectly suit your needs and elevate your boating experience</p>
                </div>
                
                <div className="service-content">
                    <div className="service-features">
                        <h3>What's Included</h3>
                        <div className="features-grid">
                            {decorationFeatures.map((feature, index) => (
                                <div key={index} className="feature-item">
                                    <FontAwesomeIcon icon={feature.icon} />
                                    <span>{feature.text}</span>
                                </div>
                            ))}
                        </div>
                        
                        <div className="gallery-button-container">
                            <button 
                                className="gallery-button"
                                onClick={openGalleryModal}
                            >
                                <FontAwesomeIcon icon={faImages} />
                                <span>View Gallery</span>
                            </button>
                        </div>
                    </div>
                    
                    <div className="service-cta">
                        <div className="cta-content">
                            <h3>Download Our Decoration Guide</h3>
                            <p>Discover our Basic, Standard, and Premium packages with detailed inclusions</p>
                            <div className="cta-buttons">
                                <button 
                                    className="cta-button primary"
                                    onClick={() => openPdfModal('decorations')}
                                >
                                    <FontAwesomeIcon icon={faEye} />
                                    <span>Preview Guide</span>
                                </button>
                                <button 
                                    className="cta-button secondary"
                                    onClick={() => { setIsModalOpen(true); setLeadModalType('decorations'); }}
                                >
                                    <FontAwesomeIcon icon={faStar} />
                                    <span>Book Decorations</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
      </main>
      
      <FAQ />
      
      {/* PDF Modal */}
      {showPdfModal && (
        currentPdf === 'decorations' ? (
          <PDFViewer
            images={[
              DecorationPDF1,
              DecorationPDF2,
              DecorationPDF3,
              DecorationPDF4,
              DecorationPDF5,
              DecorationPDF6,
              DecorationPDF7
            ]}
            title="Decoration Guide"
            onClose={closePdfModal}
            onBookNow={() => {
              closePdfModal();
              setIsModalOpen(true);
              setLeadModalType('decorations');
            }}
          />
        ) : currentPdf === 'catering-menu' ? (
          <PDFViewer
            images={[
              CateringPDF1,
              CateringPDF2,
              CateringPDF3,
              CateringPDF4,
              CateringPDF5,
              CateringPDF6,
              CateringPDF7,
              CateringPDF8,
              CateringPDF9,
              CateringPDF10,
              CateringPDF11,
              CateringPDF12,
              CateringPDF13,
              CateringPDF14,
              CateringPDF15,
              CateringPDF16,
              CateringPDF17,
              CateringPDF18,
              CateringPDF19,
              CateringPDF20,
              CateringPDF21,
              CateringPDF22,
              CateringPDF23,
              CateringPDF24,
              CateringPDF25,
              CateringPDF26,
              CateringPDF27,
              CateringPDF28,
              CateringPDF29,
              CateringPDF30,
              CateringPDF31,
              CateringPDF32,
              CateringPDF33,
              CateringPDF34,
              CateringPDF35,
              CateringPDF36,
              CateringPDF37,
              CateringPDF38
            ]}
            title="Catering Menu"
            onClose={closePdfModal}
            onBookNow={() => {
              closePdfModal();
              setIsModalOpen(true);
              setLeadModalType('catering');
            }}
          />
        ) : currentPdf === 'liquor-menu' ? (
          <PDFViewer
            images={[
              LiquorsPDF1,
              LiquorsPDF2,
              LiquorsPDF3,
              LiquorsPDF4,
              LiquorsPDF5,
              LiquorsPDF6
            ]}
            title="Liquor Menu"
            onClose={closePdfModal}
            onBookNow={() => {
              closePdfModal();
              setIsModalOpen(true);
              setLeadModalType('catering');
            }}
          />
        ) : (
          <div className="core__modal" onClick={closePdfModal}>
              <div className="core__modal-content" onClick={(e) => e.stopPropagation()}>
                  <div className="core__modal-header">
                      <h3>
                          Catering & Liquor Menus
                      </h3>
                      <button className="core__modal-close" onClick={closePdfModal}>
                          <FontAwesomeIcon icon={faTimes} />
                      </button>
                  </div>
                  <div className="core__modal-body">
                      <div className="pdf-preview">
                          <div className="brochure-previews">
                              <div className="brochure-item">
                                  <div className="brochure-placeholder catering">
                                      <FontAwesomeIcon icon={faUtensils} className="brochure-icon" />
                                      <span>MR. SEA</span>
                                      <h4>CATERING</h4>
                                  </div>
                                  <p>Food Menu</p>
                              </div>
                              <div className="brochure-item">
                                  <div className="brochure-placeholder liquor">
                                      <FontAwesomeIcon icon={faWineBottle} className="brochure-icon" />
                                      <span>MR. SEA</span>
                                      <h4>LIQUOR</h4>
                                  </div>
                                  <p>Liquor List</p>
                              </div>
                          </div>
                      </div>
                      <div className="core__modal-buttons">
                          <a 
                              href={'https://drive.google.com/drive/folders/12NKQFyVcc8we2zIXAAgCjn8iX4AUKacH'}
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="button"
                          >
                              <span>Download Menus</span>
                          </a>
                          <button 
                              className="button secondary"
                              onClick={() => {
                                  closePdfModal();
                                  setIsModalOpen(true);
                                  setLeadModalType('catering');
                              }}
                          >
                              <span>Book Now</span>
                          </button>
                      </div>
                  </div>
              </div>
          </div>
        )
      )}
      
      {isModalOpen && <CustomBoatLeadModal onClose={() => { setIsModalOpen(false); setLeadModalType(null); }} catering={leadModalType === 'catering'} decorations={leadModalType === 'decorations'} />}
      
      {showGalleryModal && (
        <ServicesGalleryModal
          images={servicesGalleryImages}
          currentIndex={galleryCurrentIndex}
          onClose={closeGalleryModal}
          onChangeIndex={setGalleryCurrentIndex}
        />
      )}
    </div>
  );
};

export default ServicesPage;
